import { createAction, props } from '@ngrx/store';
import { SentEmails } from './sent-emails.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records sent emails'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records sent emails success', 
    props<{ listData: SentEmails[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records sent emails failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state sent emails',
);